<template lang="html">
<div>
  <filter-sidebar v-model="formattedFilters" :isSidebarActive="showSidebar" @submit="applyFilters" @closeSidebar="toggleSidebar"  />
  <vs-card v-if="!displayForm" class="cardx">
    <div slot="header" style="padding:10px">
      <h3>
        Drivers
      </h3>
    </div>
    <div>
          <vs-row style="margin-bottom:0px;">
            <vs-col vs-lg="6" vs-sm="6" vs-xs="12">
              <vs-row> 
                <div style="margin-bottom: 5px; margin-left: 15px;">
                  <vs-button @click="MassLoad" color="primary" type="filled" icon="arrow_downward" size="small">Import</vs-button>
                </div>   
                <div style=" margin-bottom: 5px; margin-left: 15px;">
                  <vs-button @click="Exportxls" color="primary" type="filled" icon="arrow_upward" size="small">Export</vs-button>
                </div>   
                <div style=" margin-bottom: 5px; margin-left: 15px;">
                  <a href="/partner/drivers/add" target="_self">
                  <vs-button   color="primary" type="filled" icon="add" size="small">New</vs-button> 
                </a>
                </div> 
              </vs-row>
            </vs-col>

 

            <vs-col vs-lg="3" vs-sm="3" vs-xs="12"    >
              
                <vs-chip transparent  @click="toggleSidebar(true)" closable close-icon="add"  style="float:right; margin-right: 10px; margin-top: 5px;">
                  Add Filter
                </vs-chip>
                <vs-chip v-if="['partner_id','driver_id'].indexOf(key) > -1"
                         transparent color="primary" :key="'el-'+key" v-for="(filter,key) of formattedFilters" @click="removeFilter(key)" closable  style="float:right;   margin-right: 10px;  ">
                  <UserIcon v-if="key === 'driver_id'" size="12" class="mr-2" /> 
                  <b >{{filter.field}}</b>: {{filter.text}}
                </vs-chip>
              
              </vs-col>

            <vs-col vs-lg="3" vs-sm="3  " vs-xs="12"    >  
                  <vs-dropdown class="mr-2"  vs-custom-content vs-trigger-click vs-drop-right :vs-dropdown-visible="true" style="float:right" >
                    <vs-chip transparent color="primary" style="min-width: 130px;">
                      <b>From</b>: {{since}}
                    </vs-chip>
                    <vs-dropdown-menu class="loginx">
                      <datepicker @input="updateDateQuery" calendar-class="border-none" :inline="true" v-model="dates.since" format="yyyy-MM-dd"></datepicker>
                    </vs-dropdown-menu>
                  </vs-dropdown>

                  <vs-dropdown class="mr-2 "  vs-custom-content vs-trigger-click vs-drop-right :vs-dropdown-visible="true" style="float:right" >
                    <vs-chip transparent color="primary" style="min-width: 130px;">
                      <b>To</b>: {{until}}
                    </vs-chip>
                    <vs-dropdown-menu class="loginx">
                      <datepicker @input="updateDateQuery" calendar-class="border-none" :inline="true" v-model="dates.until" format="yyyy-MM-dd"></datepicker>
                    </vs-dropdown-menu>
                  </vs-dropdown>
            </vs-col>
          </vs-row>
      <vs-table
        stripe 
        search
        :sst="true"
        @search="handleSearch" 
        :data="drivers.drivers">
        <template v-if="!partner_namespace" slot="header">
        </template>
        <template slot="thead">
          <vs-th style="width: 50px;">

          </vs-th>
          <vs-th sort-key="Username">
            Name
          </vs-th>
          <vs-th sort-key="Name">
            Last Name
          </vs-th>
          <vs-th sort-key="Phone">
            Phone
          </vs-th>
          <vs-th>
            City
          </vs-th>
          <vs-th>
            Reference ID
          </vs-th>
          <vs-th>
            Status
          </vs-th>
          <vs-th>
            Action
          </vs-th>
        </template>
        <template slot-scope="{data}">
          <vs-tr :key="driver.id" v-for="driver in data">
            <vs-td>
              <img :src="driver.image ? driver.image : '/img/profile.png'" style="width: 30px;height: 30px;" />
            </vs-td>
            <vs-td>
              {{driver.firstname}}
            </vs-td>
            <vs-td>
              {{driver.lastname}}
            </vs-td>
            <vs-td>
              {{driver.phone}}
            </vs-td>
            <vs-td>
              {{driver.city}}
            </vs-td>
            <vs-td>
              {{driver.reference_id}} 
            </vs-td>
            <vs-td>
              <vs-chip transparent :color="driver.is_active ?'success':'warning'">
                {{driver.is_active ? 'Enabled':'Disabled'}}
              </vs-chip>
            </vs-td>
            <vs-td>
              <feather-icon icon="ListIcon" @click="changueView(driver.id)" class="cursor-pointer navbar-fuzzy-search mr-4" />
              <feather-icon icon="EditIcon" @click="edit(driver.id)" class="cursor-pointer navbar-fuzzy-search mr-4" />
              <feather-icon icon="Trash2Icon" @click="openConfirm(driver.id)" class="cursor-pointer navbar-fuzzy-search mr-4" />
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
      <div class="mt-3 mb-3">
         <span style="float:left;">
                  <vs-select
                    @input="filters.page=1"
                    class=""
                    label=""
                    v-model="filters.limit"
                    width="100px"
                    size="small"

                  >
                    <vs-select-item :key="'lim-'+index" :value="item.value" :text="item.text" v-for="(item,index) in limitOptions" />
                  </vs-select>
                </span>
        <pagination :last-page="drivers.pagination.pages" v-model="filters.page" />
      </div>

    </div>
  </vs-card>

    <vs-card v-if="displayForm" class="cardx card-100-h" v-bind:style="{'height': (windowHeight-155)+'px'}">
      <div >
        <vs-row >
          <vs-col  vs-lg="6" vs-sm="6" vs-xs="12" style="padding:10px"> 
            <div >
              <h3 style="margin-bottom: 10px;">{{formTitle}}</h3> 

              <div>
                
        <vs-row >
          <vs-col  vs-lg="12" vs-sm="12" vs-xs="12" style="padding:10px"> 
            
            <label class="vs-input--label">Partner</label>
            <v-select
              v-model="partner_id"
              name="partner"  
              :options="partners.partners"
              :reduce="el => el.id" label="name"  />
            </vs-col>
            </vs-row>   
        <vs-row >
          <vs-col  vs-lg="6" vs-sm="6" vs-xs="12" style="padding:10px"> 
            

      <input accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel, .csv"
             ref="file"  
             type="file" 
             @click="uploadFile"   >
            </vs-col>
            </vs-row>   
              </div>
              <div class="mb-4">
                <vs-button class="mr-3" @click="Masssave" color="primary" type="filled" :disabled='showError'>Guardar</vs-button>
                <vs-button @click="cancel" color="danger" type="filled">Cancelar</vs-button>
              </div>
            </div>
          </vs-col> 
        </vs-row>


        
      <vs-row v-if="showError" >
        <vs-col vs-lg="12" vs-sm="12" vs-xs="12" style="padding:10px">
          <h3>Import error</h3>
        </vs-col>  
        <vs-col vs-lg="12" vs-sm="12" vs-xs="12" style="padding:10px"> 
          <vs-table stripe :data="errors_array"> 
            <template slot="thead">
              <vs-th>
                Line
              </vs-th>
              <vs-th>
                Phone
              </vs-th>
              <vs-th>
                Reference Id
              </vs-th>
              <vs-th>
                Username
              </vs-th>
            </template> 
            <template slot-scope="{data}">
              <vs-tr :key="indextr" v-for="(tr, indextr) in data" >
                <vs-td :data="indextr"> 
                  {{parseInt(Object.keys(data[indextr]))}}
                </vs-td>
                <vs-td  v-if="data[indextr][parseInt(Object.keys(data[indextr]))].phone" > 
                  {{data[indextr][parseInt(Object.keys(data[indextr]))].phone[0]}}
                </vs-td> 
                <vs-td  v-else>  
                </vs-td>  
                <vs-td  v-if="data[indextr][parseInt(Object.keys(data[indextr]))].reference_id" > 
                  {{data[indextr][parseInt(Object.keys(data[indextr]))].reference_id[0]}}
                </vs-td> 
                <vs-td  v-else>  
                </vs-td> 
                <vs-td v-if="data[indextr][parseInt(Object.keys(data[indextr]))].username">
                  {{data[indextr][parseInt(Object.keys(data[indextr]))].username[0]}}
                </vs-td>
                <vs-td  v-else>  
                </vs-td>
                

              </vs-tr>
            </template>
          </vs-table>
            <vs-row>
              <vs-col style="marginTop:10px"> 
                <vs-button @click="showError = false" color="primary" type="filled"   size="small">Ok</vs-button>
              </vs-col> 
            
            </vs-row>


        </vs-col> 


      </vs-row> 
      </div>
    </vs-card>


    <vs-popup @close="showProgress = false" button-close-hidden	 class="crop-modal"  title="Import Progress" :active.sync="showProgress"  >
      <vs-row >
        <vs-col vs-lg="12" vs-sm="12" vs-xs="12" style="padding:10px">
           Progress of import to {{this.partnernamespace}}
        </vs-col>  
        <vs-col vs-lg="12" vs-sm="12" vs-xs="12" style="padding:10px">   
           <div :style="{ background: 'red',height: '15px',width:(progress)+'%' }"  ></div> <div style="fontSize:1rem;fontWeight: bold;color: red;textAlign:center;">{{progress}}%</div>
        </vs-col> 
        <vs-col vs-lg="12" vs-sm="12" vs-xs="12" style="padding:10px;textAlign:center;" v-if="progress===100">
           <vs-button @click="showProgress = false" color="primary" type="filled"   size="small">Ok</vs-button>
        </vs-col>   
      </vs-row>
    </vs-popup>


    
    </div>
</template>


<script>
import { mapActions, mapState, mapGetters, mapMutations} from 'vuex'
import limitOptions from "../../constants/limit";
import moment from 'moment'
import FilterSidebar from "./FilterSidebar";
import Datepicker from 'vuejs-datepicker';
import axios from '@/api'
import { CalendarIcon } from 'vue-feather-icons'
const FileDownload = require('js-file-download');

export default {

    components: {
      Datepicker,
      CalendarIcon,
      FilterSidebar,
    },
	data (){
		return {
		  page:0,
      partner_id : null,
      search : null,
      filters: {},
      limitOptions,
      formTitle : '',
      formattedFilters : {},
      displayForm : false,
      windowHeight: 0,
      showSidebar : false,
      showError: false,
      showProgress: false,
      progress: 0,
      errors_detail: null,
      errors_array: null,
      partnernamespace: null,
      dates : {
        page: 0,
        since: moment().subtract(1,'weeks').toDate(),
        until: moment().toDate()        },
		  }
	},
	computed : {
    ...mapState(['partner_namespace']),
    ...mapGetters('users',['userCan']),
		...mapState('drivers',['drivers','currentPage']),
    ...mapState('partners',['partners']),
      since(){
        return moment(this.dates.since).format('YYYY-MM-DD');
      },
      until(){
        return moment(this.dates.until).format('YYYY-MM-DD');
      },
	},
	created () {
    this.filters = {
      limit: '20',
      ...this.$route.query,
      page: this.$route.query.page ? Number(this.$route.query.page) : 1,
    };
    this.doSearch = _.debounce(this.getItems,300);
    
          this.fetchPartners({limit: 500}).then(data=>{  
            if(this.partner_namespace){ 
                  data.data.partners.map(item => {  
                    if(this.partner_namespace=== item.id){ 
                        let temparray= [];
                        temparray.push(item)
                        this.partners.partners = _.cloneDeep(temparray); 
                    } 
                    })

            }else{
                  this.partners.partners = _.cloneDeep(data.data.partners); 
            }
           
          }); 
	},
  watch : {
    filters : {
      deep: true,
      handler(newVal, oldVal){
        this.setRouteQuery();
        //if(!_.isEqual(newVal, oldVal))
        this.doSearch();
      }
    }
  },
  mounted() { 
    this.windowHeight = window.innerHeight;
  },
	methods: {   
		...mapActions('drivers',['fetchDrivers','deleteDriver','fetchDrivesReport','MassLoadDrivers','CheckDriverProgress']),
    ...mapActions('partners',['fetchPartners']),
    ...mapMutations('drivers',['SET_FILTERS']),
    setRouteQuery(){
      let query = {...this.filters, page: `${this.filters.page}`};
      if(!_.isEqual(query, this.$route.query)){
        try{
          this.$router.push({query});
        }catch(error){

        }
      }
    }, 
      MassLoad(){
        this.formTitle = 'Mass Charge'; 
        this.displayForm = true; 
      },
      ChangePartner(){
        console.log('ChangePartner') 
      },
      uploadFile(){
        this.showError=false;

      },
      Exportxls(){
        var targetexport= {
          ...this.filters,
          export: true,
          format: 'csv'
        } 

        if(this.partner_namespace!=null){ 
        targetexport.partner_id= this.partner_namespace; 
        }else{  
          
        } 
        targetexport.page=1;
        this.$vs.loading({type:'point'});
        this.fetchDrivesReport(targetexport)
          .then(data=>{
            FileDownload(data, `drivers-${this.since}-${this.until}.csv`);
            this.$vs.loading.close();
          })
          .catch(error=>{
            this.$vs.loading.close();
          })
      },
      Masssave(){
        console.log('+++SAVE ZONE++')
        if(this.partner_id){
          console.log('+++this.partner_id++', this.partner_id)
          this.handleFilesUpload()
        }else{
          alert('Select a partner.')
        } 
      },
      cancel(){
        this.displayForm = false;
      },
    getItems(search){
      if(!this.userCan('drivers.read')){
        this.$vs.notify({
          color: 'danger',
          title: `Error`,
          text: 'You need permission to perform this action',
        });
        return;
      }

      let payload = _.cloneDeep(this.filters);

      if(this.partner_namespace){
        payload.partner_id= this.partner_namespace;
      }
      this.$vs.loading({type:'point'});
      console.log('\n\n\n')
      console.log('payload:',payload)
      console.log('\n\n\n')
      this.fetchDrivers(payload).then(data=>{
        this.$vs.loading.close();
      })
      .catch(error =>{
        this.$vs.loading.close();
      })
    },
    handleSearch(searching){
      this.filters = {...this.filters, page: 1, search: searching};
    },

    toggleSidebar(val = false){
      this.showSidebar = val;
    },
    applyFilters(filters){
      console.log('applyFilters:', filters)
      if(filters.partner_id){
              this.filters = {...this.filters, page: 1, partner_id: filters.partner_id.value};
      }
      if(filters.driver_id){
              this.filters = {...this.filters, page: 1, search: filters.driver_id.text};
      }
      this.filters = {...this.filters, page: 1, search: searching};
      this.page = 1;
      //this.query = {date: this.query.date, ...filters};
      //this.getItems();
    },
    removeFilter(key){
      let filters = _.cloneDeep(this.formattedFilters);
      delete filters[key];
      this.SET_FILTERS(filters);
    },
      handleFilesUpload(){
        this.submitFile(this.$refs.file.files[0]);
      },
      checkprogress(data_id){
        let payload= { task_id : data_id}
        this.CheckDriverProgress(payload).then(data=>{ 
          for (var i=0; i < this.partners.partners.length; i++) {
              if (this.partners.partners[i].id === this.partner_id) { 
                  this.partnernamespace= this.partners.partners[i].name;
              }
          }
          this.progress= 0;    
          this.showProgress=true;
          if(data.progress!=100){
            this.progress= data.progress; 
            setTimeout( ()=> { 
              this.checkprogress(data_id);
            }, 1000);
          }else{  
              this.progress= 100; 
              this.displayForm=false;
              this.getItems();
          }
          this.$vs.loading.close();
        })
        .catch(error =>{
          console.log('CheckDriverProgress error:', error)
          alert('Error on Import.')
          this.progress= 0;    
          this.showProgress=false;
          this.$vs.loading.close();
        })
      },
      submitFile(file){
        this.$vs.loading({type:'point'}); 
        let formData = new FormData();
        formData.append('file', file); 
        formData.append('partner_id', this.partner_id); 
        console.log('MassLoadDrivers',formData)   
        this.MassLoadDrivers(formData)
          .then(data=>{ 
            console.log('data:', data)
            if(data.id){
              this.checkprogress(data.id)
              this.$vs.loading.close();
            }
          })
          .catch(error=>{
            console.log('error:', error)
            if(error.status===400){ 
              this.errors_array= null;
              this.errors_array= error.data.errors;
              this.errors_detail= error.data.detail;
              this.showError=true;
            }
            this.$vs.loading.close();
          })
 
      },

      updateDateQuery(){
        console.log('update query')

        this.page = 1;
        this.filters = {
          ...this.filters,
          page: '1',
          since: this.since,
          until : this.until,
        }
      },
    openConfirm(id){
      if(!this.userCan('drivers.delete')){
        this.$vs.notify({
          color: 'danger',
          title: `Error`,
          text: 'You need permission to perform this action',
        });
        return;
      }

      this.$vs.dialog({
        type:'confirm',
        color: 'danger',
        title: `Confirm`,
        text: "Are you sure yo want to delete this record?\n This cannot be undone!",
        accept:()=>{
          this.deleteDriver({id})
            .then(data=>{
              this.$vs.notify({
                color:'success',
                title:'Success',
                text:'Deleted successfully'
              });
              this.getItems();
            })
            .catch(error=>{
              this.$vs.notify({
                color:'danger',
                title:'Error',
                text:'Something went wrong'
              })
            });
        }
      })
    },
    edit(id){
      if(this.partner_namespace){
        this.$router.push({name: 'partner.drivers.edit', params:{id}})
      }else{
        this.$router.push({name: 'drivers.edit', params:{id}})
      }
    },
    changueView(id){
        if(this.partner_namespace){
          this.$router.push({name: 'partner.drivers.Logs', params:{id}})
        }else{
          this.$router.push({name: 'drivers.Logs', params:{id}})
        }
      },
	}

}
</script>
